<template>
<section class="container">
    <Scroll
      :data="dataList"
      :allLoaded="allLoaded"
      @pulldown="loadData"
      @loadUp="loadup"
      v-if="dataList.length > 0"
    >
    <div class="dataList">
      <div class="recordItem" v-for="(item,index) in dataList" :key="index">
        <coupon-item @itemClick="itemClick" :item="item"></coupon-item>
      </div>
    </div>
   </Scroll>
   <div class="no_mess" v-if="dataList.length == 0 && loaded">
    <img src="../../../assets/images/img_blank_coupon_park.png" />
    <p>还没有停车券~</p>
   </div>
</section>
</template>

<script>
import util from '../../../utils/util';
import {freeCall} from '../../../utils/api';
import Scroll from "../../../components/scroll";
import {mapState} from 'vuex';
import CouponItem from '../../parkingCoupon/components/couponItem'
export default {
  name: 'parkingRecord',
  props: {
    parkHeaderId:{
      type:Number,
      default:0
    },
    parkName:{
      type:String,
      default:''
    },
    tab:{
      type:Number,
      default:0
    }
  },
  components: {
    Scroll,
    CouponItem
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      pageNo:1,
      pageSize: 10,
      allLoaded: false, // 可以进行上拉
      loaded: false,
      dataList:[],
    }
  },
  created(){
   this.fetchData();
  },
  methods:{
    // 上拉加载
    loadup() {
      if (this.allLoaded) {
        return;
      }
      this.pageNo++;
      this.fetchData();
    },
    // 下拉刷新
    loadData() {
      this.pageNo = 1;
      this.fetchData();
    },
    fetchData(){
      util.showLoading()
      let params = {
        prkHeaderId:this.parkHeaderId,
        openId: this.common.openId,
        pageSize:this.pageSize,
        pageNo:this.pageNo,
        url: "/parking/rstParkCoupon/queryMyCouponList"
      }
      freeCall(params).then(res => {
        this.loaded = true;
        util.hideLoading();
        console.log(res)
        if (res.res.code === 10000 && res.body) {
          if(this.pageNo == 1){
            this.dataList = res.body.data || [];
          }else{
            this.dataList = this.dataList.concat(res.body.data)
          }
          if(this.dataList.length != this.pageSize){
            this.allLoaded = true;
          }
        } else {
          util.showToast(res.res.msg);
        }
      })
    },
    itemClick(){
      this.$emit("couponClick")
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.container{
  height:100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  .dataList{
    flex: 1;
    padding-top: 20px;
  }
  .recordItem{
    margin: 0 20px 20px;
    width: 710px;
    border-radius: 8px;
    background: #fff;
    .dataItem_top{
      height: 88px;
      display: flex;
      padding: 0 28px;
      align-items: center;
      border-bottom: 1px solid #EAEAEA;
      .top_left{
        flex: 1;
        text-align: left;
        font-size:32px;
        color: #333;
      }
      .top_right{
        flex: 1;
        text-align: right;
        color: #FC3F56;
        font-size:28px;
      }
    }
    .dataItem_center{
      min-height: 192px;
      .center_line{
        display: flex;
        padding: 0 28px;
        align-items: center;
        height: 64px;
        .center_title{
          width: 152px;
          font-size:26px;
          color: #666;
        }
        .center_con{
          flex: 1;
          font-size:26px;
          color: #333;
        }
      }
    }
    .dataItem_bottom{
      height: 88px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 0 28px;
      box-sizing: border-box;
      .delete{
        width:128px;
        height:52px;
        border-radius:8px;
        border:2px solid rgba(218,218,218,1);
        font-size:26px;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:52px;
        text-align: center;
      }
    }
  }
  .no_mess {
    height: 90vh;
    .flex();
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img{
      width:368px;
      height:224px;
      margin-bottom:60px;
    }
    p{
      font-size:28px;
      color:rgba(153,153,153,1);
      line-height:40px;
      text-align:center;
    }
  }
}
</style>
